import { Context } from 'ckeditor5';
import saveAs from 'file-saver';
import { documentApi } from '../../../api/document';
import {
  API_FETCH_ATTACHMENT_BLOB_ERROR,
  logCustomError,
} from '../../../messages/LogErrorMessages';
import { refreshDisplayMode } from '../../../util/SidebarUtils';

export const handleAttachmentDownload = (
  attachmentId: string,
  mimeType: string,
  filename: string,
) => {
  documentApi
    .fetchAttachmentDataAsBlob(attachmentId, mimeType)
    .then((res) => {
      if (res && filename) {
        saveAs(res, filename);
      }
    })
    .catch((error) => {
      logCustomError(API_FETCH_ATTACHMENT_BLOB_ERROR, {
        error,
        entityId: +attachmentId,
      });
    });
};

export const resizeOnZoom = (zoom: number, context?: Context) => {
  refreshDisplayMode({
    instances: context ? [context] : [],
    windowWidth: window.innerWidth,
    forceNarrow: zoom > 1.1,
    breakpointOverride: 1800,
  });
};

export const hasXlsxExtension = (filename?: string) => {
  return filename?.split('.').pop() === 'xlsx';
};
